module.exports = __webpack_public_path__ + "static/favicon-e0764f8515d687d5a098ea766dd41dd6.png";